import {useChanges} from "../../hooks/useChanges";

import '../../styles/inputCheckBoxUser.scss'

const InputCheckBoxUser = ({ item, setCheckCurrent }) => {
    const {addChangeToStore} = useChanges();
    
    const handleCheck = () => {
        setCheckCurrent({...item, value: !item.value})
        addChangeToStore({ key: item.name, value: !item.value });
    }
    
    return (
        <div className='input_checkbox_user_wrap'>
            <div 
            className='input_checkbox_user_item'
            onClick={handleCheck}
            >
                <input  type="checkbox"  id="name_user" checked={item.value} />
                <label htmlFor="name_user">{item.text}</label>
            </div>
        </div>
    );
};

export default InputCheckBoxUser;


// import React, { useEffect, useState, useRef }  from 'react';
// import { useDispatch } from 'react-redux';
// import { setChangesDetected, addChange } from '../../store/ChangeDetected';
// import '../../styles/inputCheckBoxUser.scss'

// const InputCheckBoxUser = ({item, setUserList}) => {
    
//     const [checkBox, setCheckBox] = useState(item.value)
//     const dispatch = useDispatch();
// //     const firstRender = useRef(true);
  
// //     useEffect(() => {
// //       if (firstRender.current) {
// //     firstRender.current = false;
// //     return;
// //   }
    
// //     dispatch(setChangesDetected(true))
  
// //   }, [dispatch, checkBox]);

// const handleChange = (name) => {
//     const newValue = !item.value;
//     setUserList(prevList => prevList.map(listItem => 
//         listItem.name === name ? {...listItem, value: newValue} : listItem
//     ));
//     dispatch(addChange({ key: item.name, value: newValue }));
// }

    
//     return (
//         <div className='input_checkbox_user_wrap'>
//             <div
//             className='input_checkbox_user_item'
//             onClick={() => handleChange(item.name)}
//             >
//                 <input  type="checkbox"  id="name_user" checked={item.value} />
//                 <label htmlFor="name_user">{item.text}</label>
//             </div>
//         </div>
//     );
// };

// export default InputCheckBoxUser;



// import React, { useEffect, useState }  from 'react';
// import '../../styles/inputCheckBoxUser.scss'

// const InputCheckBoxUser = ({item}) => {
    
//     const [checkBox, setCheckBox] = useState(true)
    
//     return (
//         <div className='input_checkbox_user_wrap'>
//             <div 
//             className='input_checkbox_user_item'
//             onClick={() => setCheckBox(!checkBox)}
//             >
//                 <input  type="checkbox"  id="name_user" checked={checkBox} />
//                 <label htmlFor="name_user">{item}</label>
//             </div>
//         </div>
//     );
// };

// export default InputCheckBoxUser;